/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {switchAccount} from '../api'

export const useMutationSwitchAccount = createReactQueryMutationHook('switchAccount', switchAccount)
